module.exports = __webpack_public_path__ + "img/general-4.2.63055d66.svg";